import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-progressing',
  templateUrl: './api-progressing.component.html',
  styleUrls: ['./api-progressing.component.scss']
})
export class ApiProgressingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1830568451/src/src/app/common/api-progressing/api-progressing.component.ts